import { useQuery } from '@tanstack/react-query';
import type { IntercomTag } from '@brand24-original/llm-types';
import { getIntercomTags } from '../../services/admin/AdminIntercomService';
import { adminIntercomKeys } from '../../query/admin/keys';

/** Słownik tagów przestrzeni roboczej — opcje filtra listy kontaktów. Zmienia się rzadko. */
export const useGetIntercomTags = () => {
  const { data } = useQuery<IntercomTag[]>({
    queryKey: adminIntercomKeys.tags,
    queryFn: getIntercomTags,
    staleTime: 5 * 60_000,
  });
  return data ?? [];
};
